export default __webpack_public_path__ + "static/neue-haas-grotesk-text-55-roman-eb0d15b79d5f85059211c2a26edf0676.woff2";